import * as React from 'react';
import { useField, useFormikContext, FieldConfig } from 'formik';

import { Checkbox } from '@cvent/carina/components/Checkbox';

const FormikCheckbox = ({ ...props }: FieldConfig) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    return (
        <div className='FormikCheckbox'>
            <Checkbox
                {...field}
                {...props}
                id={'formikCheckbox'}
                checked={field.value}
                onBlur={() => {}}
                onChange={() => {
                    setFieldValue(field.name, !field.value);
                    setFieldValue('date', null);
                }}
            >
                My dates are flexible
            </Checkbox>
        </div>
    );
};

export default FormikCheckbox;
